import { Injectable, Type } from "@angular/core";
import { Route, Routes } from "@angular/router";
import { DynamicRoute, IDynamicRoutesProvider, provideRouteIdentity } from "core";
import { provideTranslocoScope } from "@jsverse/transloco";
import { RECEIPTS_DESCRIBE } from "../constants";
import { Receipts } from "../receipts/receipts"
import { ReceiptsNew } from "../receipts-new/receipts-new";
import { ReceiptsNewCustomerSummary } from "../receipts-new-customer-summary/receipts-new-customer-summary";
import { ReceiptsBrogliacci } from "../receipts-brogliacci/receipts-brogliacci";
import { ReceiptsBrogliacciNew } from "../receipts-brogliacci-new/receipts-brogliacci-new";
import { ReceiptsBrogliacciDetail } from "../receipts-brogliacci-detail/receipts-brogliacci-detail";
import { ReceiptsDistinte } from "../receipts-distinte/receipts-distinte";
import { ReceiptsDistinteNew } from "../receipts-distinte-new/receipts-distinte-new";
import { ReceiptsDistinteDetail } from "../receipts-distinte-detail/receipts-distinte-detail";
import { ReceiptsInProgress } from "../receipts-in-progress/receipts-in-progress";

@Injectable({ providedIn: 'root' })
export class ReceiptsRoutesProvider extends IDynamicRoutesProvider {

    override componentMap: Record<string, Type<any>> = {
        'receipts': Receipts,
        'receipts-list': Receipts,
    };

    // deve corrispondere all'id nel json della chiamate delle rotte
    override describe(): String {
        return 'receipts';
    }

    override evaluate(dynamicRoute: DynamicRoute[]): Routes {
        const routes = this.buildRoutes(this.keepMappedNodes(dynamicRoute), RECEIPTS_DESCRIBE);

        this.appendStaticRoutes(routes);

        return routes;
    }

    private keepMappedNodes(nodes: DynamicRoute[]): DynamicRoute[] {
        return nodes
            .filter(node => this.componentMap[node.id] !== undefined)
            .map(node => ({
                ...node,
                children: node.children ? this.keepMappedNodes(node.children) : [],
            }));
    }

    private appendStaticRoutes(routes: Routes): void {
        const parent = routes[0];

        if (!parent || !parent.children) {
            return;
        }

        parent.children.push(
            this.staticRoute('incassi-in-lavorazione', 'receipts-in-progress', ReceiptsInProgress),
            this.staticRoute('new/select-customer', 'select-customer', ReceiptsNew),
            this.staticRoute('new/:idBusinessPartner', 'new-customer-summary', ReceiptsNewCustomerSummary),
            this.staticRoute('brogliacci/new', 'receipts-brogliacci-new', ReceiptsBrogliacciNew),
            this.staticRoute('brogliacci/:idBrogliaccio', 'receipts-brogliacci-detail', ReceiptsBrogliacciDetail),
            this.staticRoute('brogliacci', 'receipts-brogliacci', ReceiptsBrogliacci),
            this.staticRoute('distinte/new', 'receipts-distinte-new', ReceiptsDistinteNew),
            this.staticRoute('distinte/:idDistinta', 'receipts-distinte-detail', ReceiptsDistinteDetail),
            this.staticRoute('distinte', 'receipts-distinte', ReceiptsDistinte),
        );
    }

    private staticRoute(path: string, id: string, component: Type<any>): Route {
        return {
            path,
            component,
            providers: [
                provideTranslocoScope(RECEIPTS_DESCRIBE),
                provideRouteIdentity(RECEIPTS_DESCRIBE, id),
            ],
        };
    }
}
